jQuery(document).ready(function(){

	// Returns width of browser viewport
	var $width = jQuery( window ).width();
	var $height = jQuery( window ).height();
	var $videoContainer =  jQuery( ".post-video-container" );
	var $videoContainerPage =  jQuery( ".kinecko-video-container" );
	var $modalJokeContainer =  jQuery( "#modal-joke-container" );
	var $modalJoke =  jQuery( ".modal-joke" );
	var $loginLink =  jQuery( "#login-menu-link" );
	var $registerLink =  jQuery( "#register-menu-link" );

	//window.alert("w:" +$width +"\/n" + "h:" +$height);

	if($width < 620 && $width > 480 ) {
		$videoContainer.find("iframe").prop("width",480);
		$videoContainer.find("iframe").prop("height",270);
	} else if ($width < 480) {
		$videoContainer.find("iframe").prop("width",340);
		$videoContainer.find("iframe").prop("height",192);
	}
	if($width < 620 && $width > 480 ) {
		$videoContainerPage.find("iframe").prop("width",480);
		$videoContainerPage.find("iframe").prop("height",270);
	} else if ($width < 480) {
		$videoContainerPage.find("iframe").prop("width",340);
		$videoContainerPage.find("iframe").prop("height",192);
	}

	if ($height < 650) {
		$modalJokeContainer.css("height", $height +"px");
		$modalJoke.css("width","90%")
	}

	//window.alert($width);





    var filters=[
		"#homeDate",
        "#homeAuthor",
        "#homeAlphabet",
        "#homeComments",
        "#homeAsc",
        "#homeDesc"
    ];

    for (i = 0; i < filters.length; i++) {
    	jQuery(filters[i]).click(function (e) {
            e.preventDefault();
            var element=jQuery(e.target);
            var dataAction = element.data('action');
            var dataData = element.data('data');

            jQuery.ajax( {
                type: "POST",
                data: {	action: dataAction, data: dataData},
                url: ajaxUrl,
                success: function ( response ) {
                    // location.reload();
                }
            } );
        });
    }



    //
    //
	// var homeDate = jQuery( "#homeDate" );
	// var homeAuthor = jQuery( "#homeAuthor" );
	// var homeAlphabet = jQuery( "#homeAlphabet" );
	// var homeComments = jQuery( "#homeComments" );
	// var homeAsc = jQuery( "#homeAsc" );
	// var homeDesc = jQuery( "#homeDesc" );
    //
    //
	// homeDate.click(function (e) {
	// 		e.preventDefault();
	// 		jQuery.ajax( {
	// 			type: "POST",
	// 			data: {	action: "post_filter", data: 'date'},
	// 			url: ajaxUrl,
	// 			success: function ( response ) {
	// 				location.reload();
	// 			}
	// 		} );
	// });
	// homeAlphabet.click(function (e) {
	// 	e.preventDefault();
	// 	jQuery.ajax( {
	// 		type: "POST",
	// 		data: {	action: "post_filter", data: 'name'},
	// 		url: ajaxUrl,
	// 		success: function ( response ) {
	// 			location.reload();
	// 		}
	// 	} );
	// });
	// homeAuthor.click(function (e) {
	// 	e.preventDefault();
	// 	jQuery.ajax( {
	// 		type: "POST",
	// 		data: {	action: "post_filter", data: 'author'},
	// 		url: ajaxUrl,
	// 		success: function ( response ) {
	// 			location.reload();
	// 		}
	// 	} );
	// });
    //
	// homeComments.click(function (e) {
	// 	e.preventDefault();
	// 	jQuery.ajax( {
	// 		type: "POST",
	// 		data: {	action: "post_filter", data: 'comment_count'},
	// 		url: ajaxUrl,
	// 		success: function ( response ) {
	// 			location.reload();
	// 		}
	// 	} );
	// });
    //
	// homeAsc.click(function (e) {
	// 	e.preventDefault();
	// 	jQuery.ajax( {
	// 		type: "POST",
	// 		data: {	action: "post_order", data: 'ASC'},
	// 		url: ajaxUrl,
	// 		success: function ( response ) {
	// 			location.reload();
	// 		}
	// 	} );
	// });
    //
	// homeDesc.click(function (e) {
	// 	e.preventDefault();
	// 	jQuery.ajax( {
	// 		type: "POST",
	// 		data: {	action: "post_order", data: 'DESC'},
	// 		url: ajaxUrl,
	// 		success: function ( response ) {
	// 			location.reload();
	// 		}
	// 	} );
	// });
    //



	//Menu Button
	jQuery(function(){

		function wait(timeout) {
			var deferred = jQuery.Deferred();
			setTimeout(deferred.resolve, timeout);
			return deferred.promise();
		}

        jQuery(window).scroll(function() {
            if(jQuery(this).scrollTop() > 300) {
                jQuery('#up').addClass('visible');
            } else {
                jQuery('#up').removeClass('visible');
            }
        });

        jQuery('#upto').click(function () {
            console.log('log');
            jQuery('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });


		jQuery('#menu-trigger').click(function () {
			var nav = jQuery('#main-navigation');
			if(!nav.hasClass('menu-open')) {
				nav.addClass('menu-open');
				nav.removeClass('menu-close');
				nav.animate({
					opacity:1
				}, 300);
				nav.animate({
					right: (0)
				}, 300);
					/*
					nav.addClass('add');
					nav.removeClass('remove');*/

			} else {
				nav.animate({
					opacity:0
				}, 300);
				nav.animate({
					right: 0
				}, 300, function () {
					nav.addClass('menu-close');
					nav.removeClass('menu-open');
				});

			}
		});
		jQuery('#modal-menu-cross').click(function () {
			var nav = jQuery('#main-navigation');
			if(!nav.hasClass('menu-open')) {
				nav.addClass('menu-open');
				nav.removeClass('menu-close');
				nav.animate({
					opacity:1
				}, 300);
				nav.animate({
					right: (0)
				}, 300);
				/*
				nav.addClass('add');
				nav.removeClass('remove');*/

			} else {
				nav.animate({
					right: 0,
				}, 300, function () {
					nav.addClass('menu-close');
					nav.removeClass('menu-open');
				});
				nav.animate({
					opacity:0
				}, 300);

			}
		});
		$loginLink.click(function () {
			var nav = jQuery('#main-navigation');
			if(!nav.hasClass('menu-open')) {
				nav.addClass('menu-open');
				nav.removeClass('menu-close');
				nav.animate({
					opacity:1
				}, 300);
				nav.animate({
					right: (0)
				}, 300);
				/*
				nav.addClass('add');
				nav.removeClass('remove');*/

			} else {
				nav.animate({
					right: 0,
				}, 300, function () {
					nav.addClass('menu-close');
					nav.removeClass('menu-open');
				});
				nav.animate({
					opacity:0
				}, 300);

			}
		});
		$registerLink.click(function () {
			var nav = jQuery('#main-navigation');
			if(!nav.hasClass('menu-open')) {
				nav.addClass('menu-open');
				nav.removeClass('menu-close');
				nav.animate({
					opacity:1
				}, 300);
				nav.animate({
					right: (0)
				}, 300);
				/*
				nav.addClass('add');
				nav.removeClass('remove');*/

			} else {
				nav.animate({
					right: 0,
				}, 300, function () {
					nav.addClass('menu-close');
					nav.removeClass('menu-open');
				});
				nav.animate({
					opacity:0
				}, 300);

			}
		});

		jQuery('#filter-trigger').click(function () {
			var filter = jQuery('#main-filter');
			if(!filter.hasClass('filter-open')) {
				filter.addClass('filter-open');
				filter.removeClass('filter-closed');
				filter.animate({
					opacity:1
				}, 300);
				filter.animate({
					top: (0)
				}, 0);
				/*
				filter.addClass('add');
				filter.removeClass('remove');*/
				console.log('filter');

			} else {
				filter.animate({
					opacity:0
				}, 300);
				filter.animate({
					top: -300
				}, 300, function () {
					filter.addClass('filter-closed');
					filter.removeClass('filter-open');
				});
			}
		});
		jQuery('#filter-cross').click(function () {
			var filter = jQuery('#main-filter');
			if(!filter.hasClass('filter-open')) {
				filter.addClass('filter-open');
				filter.removeClass('filter-closed');
				filter.animate({
					opacity:1
				}, 300);
				filter.animate({
					top: (0)
				}, 300);
				/*
				filter.addClass('add');
				filter.removeClass('remove');*/
				console.log('filter');

			} else {
				filter.animate({
					opacity:0
				}, 300);
				filter.animate({
					top: -300
				}, 300, function () {
					filter.addClass('filter-closed');
					filter.removeClass('filter-open');
				});
			}
		});


		jQuery('#modal-joke-trigger').click(function () {
			var joke = jQuery('#modal-joke-container');
			if(!joke.hasClass('joke-open')) {
				joke.addClass('joke-open');
				joke.removeClass('joke-closed');
				joke.animate({
					opacity:1
				}, 300);
				joke.animate({
					bottom: (0)
				}, 300);
				/*
				joke.addClass('add');
				joke.removeClass('remove');*/
				console.log('joke');

			} else {
				joke.animate({
					opacity:0
				}, 300);
				var newHeight = 650;
				if ($height < 650) {
					newHeight = $height;
				}
				joke.animate({
					bottom: - newheight
				}, 300, function () {
					joke.addClass('joke-closed');
					joke.removeClass('joke-open');
				});
			}
		});
		jQuery('#modal-joke-cross').click(function () {
			var joke = jQuery('#modal-joke-container');
			if(!joke.hasClass('joke-open')) {
				joke.addClass('joke-open');
				joke.removeClass('joke-closed');
				joke.animate({
					opacity:1
				}, 300);
				joke.animate({
					bottom: (0)
				}, 300);
				/*
				joke.addClass('add');
				joke.removeClass('remove');*/
				console.log('joke');

			} else {
				joke.animate({
					opacity:0
				}, 300);
				var newHeight = 650;
				if ($height < 650) {
					newHeight = $height;
				}
				joke.animate({
					bottom: - newHeight
				}, 300, function () {
					joke.addClass('joke-closed');
					joke.removeClass('joke-open');
				});
			}
		});

        jQuery('#modal-newsletter-trigger').click(function () {
            var newsletter = jQuery('#modal-newsletter-container');
            if(!newsletter.hasClass('newsletter-open')) {
                newsletter.addClass('newsletter-open');
                newsletter.removeClass('newsletter-closed');
                newsletter.animate({
                    opacity:1
                }, 300);
                newsletter.animate({
                    bottom: (0)
                }, 300);
                /*
                newsletter.addClass('add');
                newsletter.removeClass('remove');*/
                console.log('newsletter');

            } else {
                newsletter.animate({
                    opacity:0
                }, 300);
                newsletter.animate({
                    bottom: -300
                }, 300, function () {
                    newsletter.addClass('newsletter-closed');
                    newsletter.removeClass('newsletter-open');
                });
                console.log('no newsletter');
            }
        });
        jQuery('#modal-newsletter-cross').click(function () {
            var newsletter = jQuery('#modal-newsletter-container');
            if(!newsletter.hasClass('newsletter-open')) {
                newsletter.addClass('newsletter-open');
                newsletter.removeClass('newsletter-closed');
                newsletter.animate({
                    opacity:1
                }, 300);
                newsletter.animate({
                    bottom: (0)
                }, 300);
                /*
                newsletter.addClass('add');
                newsletter.removeClass('remove');*/
                console.log('newsletter');

            } else {
                newsletter.animate({
                    opacity:0
                }, 300);
                newsletter.animate({
                    bottom: -300
                }, 300, function () {
                    newsletter.addClass('newsletter-closed');
                    newsletter.removeClass('newsletter-open');
                });
                console.log('no newsletter');
            }
        });

		jQuery('.modal-login-trigger').click(function () {
			var login = jQuery('#modal-login-container');
			if(!login.hasClass('login-open')) {
				login.addClass('login-open');
				login.removeClass('login-closed');
				login.animate({
					opacity:1
				}, 300);
				login.animate({
					top: ('30%')
				}, 300);
				/*
				login.addClass('add');
				login.removeClass('remove');*/
				console.log('login');

			} else {
				login.animate({
					opacity:0
				}, 300);
				login.animate({
					top: '-30%'
				}, 300, function () {
					login.addClass('login-closed');
					login.removeClass('login-open');
				});
				console.log('no login');
			}
		});
		jQuery('#modal-login-cross').click(function () {
			var login = jQuery('#modal-login-container');
			if(!login.hasClass('login-open')) {
				login.addClass('login-open');
				login.removeClass('login-closed');
				login.animate({
					opacity:1
				}, 300);
				login.animate({
					top: '30%'
				}, 300);
				/*
				login.addClass('add');
				login.removeClass('remove');*/
				console.log('login');

			} else {
				login.animate({
					opacity:0
				}, 300);
				login.animate({
					top: '30%'
				}, 300, function () {
					login.addClass('login-closed');
					login.removeClass('login-open');
				});
				console.log('no login');
			}
		});


		jQuery('.modal-register-trigger').click(function () {
			var register = jQuery('#modal-register-container');
			if(!register.hasClass('register-open')) {
				register.addClass('register-open');
				register.removeClass('register-closed');
				register.animate({
					top: '10%'
				}, 300);
				register.animate({
					opacity:1
				}, 300);
				/*
				register.addClass('add');
				register.removeClass('remove');*/
				console.log('register');

			} else {
				register.animate({
					top: '-10%'
				}, 300, function () {
					register.addClass('register-closed');
					register.removeClass('register-open');
				});
				register.animate({
					opacity:0
				}, 300);
				console.log('no register');
			}
		});
		jQuery('#modal-register-cross').click(function () {
			var register = jQuery('#modal-register-container');
			if(!register.hasClass('register-open')) {
				register.addClass('register-open');
				register.removeClass('register-closed');
				register.animate({
					opacity:1
				}, 300);
				register.animate({
					top: '10%'
				}, 300);
				/*
				register.addClass('add');
				register.removeClass('remove');*/
				console.log('register');

			} else {
				register.animate({
					opacity:0
				}, 300);
				register.animate({
					top: '-10%'
				}, 300, function () {
					register.addClass('register-closed');
					register.removeClass('register-open');
				});
				console.log('no register');
			}
		});
	});
});

